<template>
  <div
    @click="$emit('open', item)"
    :class="[$style.row, { [$style.open]: item.isOpen }]"
  >
    <div :class="$style.content">
      <div :class="$style.left">
        <img
          @click.stop="$emit('setVerified', item)"
          v-if="!item.isOpen && !item.verified"
          src="/icons/analytics/checkbox-gray.svg"
          alt=""
        />
        <img
          @click.stop="$emit('setVerified', item)"
          v-if="!item.isOpen && item.verified"
          src="/icons/analytics/checkbox-gray-active.svg"
          alt=""
        />
        <img
          @click.stop="$emit('setVerified', item)"
          v-if="item.isOpen && !item.verified"
          src="/icons/analytics/checkbox-white.svg"
          alt=""
        />
        <img
          @click.stop="$emit('setVerified', item)"
          v-if="item.isOpen && item.verified"
          src="/icons/analytics/checkbox-white-active.svg"
          alt=""
        />
      </div>
      <div :class="$style.right">
        <div :class="[$style.column, $style.id]">{{ item.id }}</div>
        <div :class="[$style.column, $style.date]">
          {{
            item?.start_date
              ?.substr(0, 10)
              ?.split("-")
              .reverse()
              ?.join(".") || "--:--:--"
          }}
        </div>
        <div :class="$style.column">{{ item.organization.name }}</div>
        <div :class="[$style.column, $style.period]">
          {{ item.worker.username }}
        </div>
        <div :class="[$style.column, $style.period]">
          {{ item.user.username }}
        </div>
        <div :class="$style.column">
          {{ item?.start_date?.substr(11, 8) || "--:--:--" }}
        </div>
        <div :class="$style.column">
          {{ item?.end_date?.substr(11, 8) || "--:--:--" }}
        </div>
        <div :class="[$style.column]">
          {{ item.delta }}
        </div>
        <div :class="[$style.column, $style.comment]" :title="item.admin_comment">
          <span>{{ item.admin_comment || "-" }}</span>
        </div>
      </div>
    </div>
    <SupervisionDetails
      :supervision="supervision"
      :isOpen="item.isOpen"
      @setVerifiedItem="$emit('setVerifiedItem', $event)"
      @openModal="$emit('openModal', $event)"
      @openImage="(comment, image) => $emit('openImage', comment, image)"
    />
  </div>
</template>

<script>
import SupervisionDetails from "./SupervisionDetails.vue";

export default {
  name: "SupervisionRow",
  components: {
    SupervisionDetails,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    supervision: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["open", "setVerified", "setVerifiedItem", "openModal", "openImage"],
};
</script>

<style lang="scss" module>
.row {
  font-weight: 400;
  background-color: $bg-white;
  border-radius: 0.125rem;
  border-bottom: 0.125rem solid $background;
  cursor: pointer;
  &.open {
    background-color: $gray-34;
  }
  .content {
    display: flex;
    align-items: center;
    padding: 1rem;
    gap: 1rem;
    .left {
      flex: 0 0 1.5rem;
      height: 1.5rem;
      cursor: pointer;
    }
    .right {
      flex: 1 1 auto;
      display: flex;
      justify-content: space-between;
      gap: 1rem;
      .column {
        flex: 0 1 7rem;
        display: flex;
        align-items: center;
        &.id {
          flex: 0 0 3.5rem;
        }
        &.date {
          flex: 0 0 6rem;
        }
        &.period {
          flex: 0 0 11.5rem;
        }
        &.comment {
          flex: 0 0 7rem;
          width: 7rem;
          overflow: hidden;
          
          span {
            display: block;
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}
</style>

